export default {
  name: 'bridge-learn',
  cdn: {
    edge: 'https://d1h1778jwn2brc.cloudfront.net',
    staging: 'https://d2wzd4gs88w14e.cloudfront.net',
    production: 'https://d3fuoknb3jgind.cloudfront.net',
  },
  manifest: '/learn/assets/manifests/manifest.json',
  pathPatterns: [/^\/admin/, /^\/download/, /^\/support/, /^\/$/],
  stylesheets: [
    'stylesheets_main_external_css',

    // application and module specific styles need to be loaded after framework
    // styles for now because we can't rely on proper specificity right now and
    // external component styles will clash with legacy styles
    'stylesheets_application_css',
    'stylesheets_main_admin_modules_css',
    'stylesheets_main_admin_sass_modules_css',
    'stylesheets_main_my_learning_sass_modules_css',

    // these are included to style the non-admin widgets on the custom branding page
    'stylesheets_my_learning_css',
    'stylesheets_main_authorization_modules_css',
    'stylesheets_main_my_learning_sass_modules_css',
  ],
  scripts: ['javascripts_main_js'],
  disabledNavPaths: [/^\/admin\/branding\/edit/],
};



// WEBPACK FOOTER //
// ./jsapp/main/learn-runtime.js